<template>
    <div>
      <div class="header-width divcss5">
         <productbanner></productbanner>
      </div>
      <div class=" row body-width divcss5 ">
        <productpartcontent></productpartcontent>
      </div>
    </div>
</template>
<script>
  import productbanner from "@/components/contentcoms/prodecutcontentcoms/productbanner";
  import productpartcontent from "@/components/contentcoms/indexcontentcoms/productpartcontent";
  export default {
    name: "aboutcontent",
    components: {
      productpartcontent,
      productbanner
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/productcontent.vue